import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Events as GenericEvents } from '../../../../services/events/events';
import { Commands } from '../commands/commands';

@Injectable({
  providedIn: 'root',
})
export class Events extends GenericEvents {
  
  constructor(protected override commands: Commands){
    super(commands, 'impostor');
  }

  public onPlayerJoined(): Observable<any>{
    return this.on('player:joined');
  }

  public onPlayersUpdate(): Observable<any>{
    return this.on('players:update');
  }

  public onGameStarted(): Observable<any>{
    return this.on('game:started');
  }

  public onGameEnded(): Observable<any>{
    return this.on('game:ended');
  }

  public onPlayerVoted(): Observable<any>{
    return this.on('player:voted');
  }

  public onWordGuessed(): Observable<any>{
    return this.on('word:guessed');
  }

}
